/**
 * Fait vibrer le téléphone n fois
 * @param {number} n
 * @param {number} vibrationDuration
 * @param {number} waitBetweenVibrationDuration
 * @returns {Promise<Boolean>}
 */

export const vibrate = (
  n = 4,
  vibrationDuration = 400,
  waitBetweenVibrationDuration = 2000
) => {
  let i = 0
  return new Promise((resolve) => {
    if (typeof navigator.vibrate !== 'function') {
      resolve(false)
    }

    const vibrateInterval = setInterval(() => {
      navigator.vibrate(vibrationDuration)
      i++
      if (i >= n) {
        clearInterval(vibrateInterval)
        resolve(true)
      }
    }, waitBetweenVibrationDuration)
  })
}

/**
 * Calcule et retourne la durée de la vibration total en milliseconds
 * @param {number} n
 * @param {number} vibrationDuration
 * @param {number} waitBetweenVibrationDuration
 * @returns {number}
 */
export const getVibrateTimeout = (
  n = 4,
  vibrationDuration = 400,
  waitBetweenVibrationDuration = 2000
) => {
  return (vibrationDuration * n) + (waitBetweenVibrationDuration * (n - 1))
}
